import { SectionTitle } from "../components/SectionTitle";
import { StrongLink } from "../components/StrongLink";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import { CardsGrid } from "../sections/CardsGrid";
import { Facts } from "../sections/Facts";
import { Hero } from "../sections/Hero";
import { RichText, RichTextContainer } from "../sections/RichText";
import { SectorInfo } from "../sections/SectorInfo";
import { StoriesCarousel } from "../sections/StoriesCarousel";
import { ColorShiftTrigger } from "../wrappers/ColorShift";

type Props = {
  title?: string;
};

export const ExpertiseTemplate = ({ page }: any) => {
  return (
    <>
      <ColorShiftTrigger color="white">
        <Hero {...page.hero} />
      </ColorShiftTrigger>
      <ColorShiftTrigger color="light-yellow">
        <Spacing top="lg" bottom="xs">
          <MaxWidth size="sm">
            <SectionTitle deco="topline-magenta">{page.bodyTitle}</SectionTitle>
          </MaxWidth>
        </Spacing>
        <RichTextContainer text={page.body} />
      </ColorShiftTrigger>
      <ColorShiftTrigger color="light-yellow">
        <SectorInfo {...page.sectorInfo} />
      </ColorShiftTrigger>
      <ColorShiftTrigger color="light-yellow">
        <Facts {...page.facts} />
      </ColorShiftTrigger>
      <ColorShiftTrigger color="light-green">
        <StoriesCarousel {...page.storiesCarousel} />
      </ColorShiftTrigger>
      {page.textLinks && (
        <ColorShiftTrigger color="light-green">
          <Spacing>
            <MaxWidth size="sm">
              {page.textLinks.title && (
                <SectionTitle deco="top-left-sparkle-green">
                  {page.textLinks.title}
                </SectionTitle>
              )}
              {page.textLinks.links.map((link: any) => (
                <Spacing key={link.title + link.url} size="xs">
                  <h3>{link.title}</h3>
                  {typeof link.text === "string" ? (
                    <p>{link.text}</p>
                  ) : (
                    <RichText text={link.text} />
                  )}
                  <StrongLink text={link.linkLabel} url={link.url}></StrongLink>
                </Spacing>
              ))}
            </MaxWidth>
          </Spacing>
        </ColorShiftTrigger>
      )}
      <CardsGrid {...page.related} />
    </>
  );
};
